import { formatImpact, toSigFigs } from './format';

/**
 * Format impact values with ISO 14044-appropriate significant figures.
 */
export function formatImpactValue(value: number, type: 'economic' | 'dalys' | 'pdfs' | 'capacity'): string {
    if (type === 'economic') {
        return formatImpact(value, 'usd');
    } else if (type === 'dalys') {
        return `${toSigFigs(Math.abs(value))} DALYs`;
    } else if (type === 'pdfs') {
        return `${toSigFigs(Math.abs(value))} PDF`;
    } else if (type === 'capacity') {
        return `${value.toFixed(0)} MW`;
    }
    return value.toString();
}